const getPreferenceCenterPhoneNumberInput = require("./getPreferenceCenterPhoneNumberInput");
const getLabelForInput = require("../dom/getLabelForInput");
const getPreferenceCenterPhoneNumberFormatMessage = require("./getPreferenceCenterPhoneNumberFormatMessage");

/**
 * @param preferenceCenter {HTMLElement}
 * @return {void}
 */
module.exports = function hidePreferenceCenterFormPhoneNumberError(preferenceCenter) {
    const phoneNumberInput = getPreferenceCenterPhoneNumberInput(preferenceCenter);
    const phoneNumberLabel = getLabelForInput(phoneNumberInput);
    const phoneNumberFormatMessage = getPreferenceCenterPhoneNumberFormatMessage(preferenceCenter);

    phoneNumberInput.classList.remove("invalid");
    phoneNumberLabel.classList.remove("invalid");
    phoneNumberFormatMessage.classList.remove("invalid");
}